import React from 'react';

import Css from './LabelDropdown.scss';

const labelDropdown = props => {
  return (
    <div className={Css['form-control']}>
      {props.label !== undefined && (
        <label htmlFor={'input-' + props.name} className={'asap-bold'}>
          {props.label}
        </label>
      )}
      <select
        type={props.type}
        name={props.name}
        id={'input-' + props.name}
        placeholder={props.label}
        onChange={event => props.onChange(event)}
        value={props.value}
      >
        {props.options.map((item, index) => {
          return (
            <option key={index} value={item}>
              {item}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default labelDropdown;



// WEBPACK FOOTER //
// ./src/components/LabelDropdown/LabelDropdown.jsx